import type { UriOrTypeId } from 'jamespot-react-components';
import { jObjectLittle } from 'jamespot-user-api';

export function getUnknownProperty(object: unknown, attribute: string): unknown | undefined {
    try {
        return (object as any)[attribute];
    } catch {
        return;
    }
}

export function ensureIsString(object: unknown): object is string {
    return typeof object === 'string';
}

export function ensureIsNumber(object: unknown): object is number {
    return typeof object === 'number';
}

export function ensureHasUriOrTypeId(object: unknown): object is UriOrTypeId {
    if (typeof object === 'object' && object !== null) {
        if ('uri' in object || ('type' in object && 'id' in object)) {
            return true;
        }
    }
    return false;
}

export function ensureObjectLittle(object: unknown): object is jObjectLittle {
    if (typeof object === 'object' && object !== null) {
        if (
            'id' in object &&
            'mainType' in object &&
            'type' in object &&
            'uri' in object &&
            'title' in object &&
            '_url' in object &&
            'dateCreation' in object &&
            'dateModified' in object
        ) {
            return true;
        }
    }
    return false;
}

export function ensureIsArray(object: unknown): object is Array<unknown> {
    return Array.isArray(object);
}
